import { BaseAPI } from "@/api/base.api";
import { API_URL_SERVICE } from "@/commons/config";
import { AxiosObservable } from "axios-observable/dist/axios-observable.interface";
import { AutorizacaoFretamento } from "@/models/autorizacaoFretamento";
import { VeiculoPendencia } from "@/models/veiculoPendencia";

export class PendenciaApi extends BaseAPI<VeiculoPendencia> {
  constructor() {
    super();
    this.apiUrl = `${API_URL_SERVICE}`;
  }

  public buscarPendencias(
    cnpj: string,
    token: string,
    recaptcha: string,
    placa: string
  ): AxiosObservable<VeiculoPendencia[]> {
    return this.axios.post(`${this.apiUrl}/api/consulta-pendencia/`, {
      cnpj,
      token,
      recaptcha,
      placa
    });
  }

  public listarPlacas(cnpj: string): AxiosObservable<string[]> {
    return this.axios.post(`${this.apiUrl}/api/consulta-pendencia/placas`, {
      cnpj
    });
  }

  public buscarMultas(
    cnpj: string,
    placa: string,
    page: number,
    size: number
  ): AxiosObservable<any> {
    return this.axios.post(`${this.apiUrl}/api/consulta-pendencia/multas`, {
      cnpj,
      placa,
      page,
      size
    });
  }
}
